import React from 'react';
import { FormikProps, withFormik } from 'formik';

import { emailSchema } from '@/services/validators/email';
import { SetCapyValues } from '@/components/shared/CapyCaptcha';
import { FormContents, Values } from './FormContents';

export type { Values } from './FormContents';

type OuterProps = {
  isDisabled: boolean;
  capyError: boolean;
  onSubmit: (values: Values) => void;
  setCapyValues: SetCapyValues;
  useTurnstile: boolean;
  turnstileError: string;
  onTurnstileSuccess: (token: string) => void;
  onTurnstileError: () => void;
  featureFlagLoading: boolean;
};

export const RemindForm = withFormik<OuterProps, Values>({
  mapPropsToValues: () => ({
    email: '',
    ignoreTurnstile: false,
    ignoreCapyCaptcha: false,
  }),
  validationSchema: emailSchema,
  handleSubmit: (values, { props, setSubmitting }) => {
    props.onSubmit(values);
    setSubmitting(false);
  },
})(
  // enhanced form
  ({
    errors,
    handleChange,
    handleSubmit,
    isDisabled = false,
    touched,
    values,
    capyError,
    setCapyValues,
    useTurnstile,
    turnstileError,
    onTurnstileSuccess,
    onTurnstileError,
    featureFlagLoading,
  }: OuterProps & FormikProps<Values>) => {
    return (
      <FormContents
        errors={errors}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        isDisabled={isDisabled}
        touched={touched}
        values={values}
        capyError={capyError}
        setCapyValues={setCapyValues}
        useTurnstile={useTurnstile}
        turnstileError={turnstileError}
        onTurnstileSuccess={onTurnstileSuccess}
        onTurnstileError={onTurnstileError}
        featureFlagLoading={featureFlagLoading}
      />
    );
  },
);
